import ConnectionState from './ConnectionState';
export default {
    /** 网络管理，待加入网络公司的连接状态 */
    ConnectionState,
};



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/networkEnum/index.ts